<template>
  <div>
    <client-only v-if="LOCALES_WITH_NEWSLETTER_POPUP.includes($locale)">
      <LazyIdleNewsletterPopup hydrate-on-idle />
    </client-only>

    <client-only v-if="canLocaleLogin">
      <LazyLoginRequestModal />
    </client-only>

    <AgentComponent no-agent-info>
      <LazyAgentCall />
      <LazyTranslationTools />
    </AgentComponent>
  </div>
</template>

<script setup lang="ts">
import { LOCALES_WITH_NEWSLETTER_POPUP } from '@packages/locale/constants/locales.ts'

const { $locale } = useNuxtApp()

const localeStore = useLocaleStore()

const { canLocaleLogin } = storeToRefs(localeStore)
</script>
